<template>
  <a-tooltip :title="text ?? '菜单绑定'" placement="top">
    <a-button @click.stop="() => open()" type="link" size="small">
      <huasky-icon icon="ShareAltOutlined" class="text-primary-color" />
    </a-button>
  </a-tooltip>
  <a-modal v-model:open="modalState.visible" @cancel="() => (modalState.visible = false)" :title="title" :width="800"
    :maskClosable="false" @ok="save">
    <a-row>
      <a-col :offset="16" :span="8">
        <a-input-search v-model:value.trim="searchKey" style="margin-bottom: 8px" placeholder="搜索" />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="11">
        <div class="box">
          <a-tree :auto-expand-parent="true" :defaultExpandAll="true" :tree-data="menus">
            <template #title="{ title, key, data }">
              <span :class="{ exist: selectedGoodIds.indexOf(key) > -1, binded: tipComputed(key).length > 0 }" :title="tipComputed(key)" @click="() => onSelect(data)">
                {{ title }}
              </span>
            </template>
          </a-tree>
        </div>
      </a-col>
      <a-col :span="2" style="display: flex; justify-content: center; align-items: center">
        <huasky-icon icon="RightOutlined" style="color: #555" />
      </a-col>
      <a-col :span="11">
        <div class="box">
          <ol style="padding: 5px">
            <li v-for="(item, index) in selectedGoods">
              <span>{{ index + 1 }}. {{ item.name }}({{ item.code }})</span>
              <huasky-icon icon="CloseOutlined" class="close" @click="() => selectedGoodIds.remove(item.id)" />
            </li>
          </ol>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script setup lang="ts">
import { getCategory, getSimpleGood } from '@src/scripts/api/good'
import { saveBindInfo } from '@src/scripts/api/setting'
import { BindType } from '@src/scripts/type'
import { computed, reactive, ref } from 'vue'

const props = defineProps<{
  text?: string,
  entity: BindEntity,
  type: BindType,
  goodIds: string[],
  storeId: string,
  entities: BindEntity[]
}>()
const emit = defineEmits(['update'])

const goods = ref<SimpleGood[]>([])           // 所有商品
const types = ref<DataDic[]>([])              // 所有类别
const searchKey = ref('')                     // 搜索的关键字
const selectedGoodIds = ref<string[]>([])     // 已选择的商品id
const modalState = reactive({
  visible: false,
})

const title = computed(() => {
  let desc = ''
  if (props.type === BindType.cook) desc = '厨师'
  else if (props.type === BindType.stall) desc = '档口'
  return props.entity.name + `【 ${desc}绑定商品 】`
})

const menus = computed<TreeData[]>(() => {
  const categories =
    types.value.map((a) => ({
      key: a.id ?? '',
      title: a.name,
      selectable: false,
      isLeaf: false,
      children: [] as TreeData[],
    })) ?? []
  let goodFilters = goods.value
  if (searchKey.value) {
    goodFilters = goodFilters.filter(a => a.name.filter(searchKey.value) || a.code.indexOf(searchKey.value) > -1)
  }
  categories.forEach((category) => {
    category.children = goodFilters.filter((a) => a.category === category.key).map((good) => {
      return { key: good.id, selectable: false, isLeaf: true, title: good.name }
    })
  })
  return categories
})

const selectedGoods = computed(() => {
  let list = selectedGoodIds.value.map((id) => goods.value.first((a) => a.id === id))
  return list.filter((a) => !!a)
})

const tipComputed = computed(() => {
  const others = props.entities.filter(a => a !== props.entity)

  return (goodId: string) => {
    const exists = others.filter(a => a.goodIds?.indexOf(goodId) > -1)
    if (exists.length === 0) return ''
    return `已在【${exists.map(a => a.name).join(',')}】中绑定`
  }
})

const open = async () => {
  if (props.storeId !== $app.store.id) {
    const { data } = await getCategory(props.storeId)
    types.value = data
  } else {
    types.value = $app.dic.goodCategory
  }
  const { data } = await getSimpleGood(props.storeId)

  goods.value = data
  modalState.visible = true
  selectedGoodIds.value = $util.clone(props.goodIds ?? [])
}

const onSelect = (data: TreeData) => {
  if (!data.isLeaf) return
  if (selectedGoodIds.value.indexOf(data.key) > -1) {
    selectedGoodIds.value.remove(data.key)
    return
  }
  selectedGoodIds.value.push(data.key)
}

const save = async () => {
  const dto = {
    id: props.entity.id,
    type: props.type,
    info: JSON.stringify(selectedGoodIds.value)
  }
  await saveBindInfo(dto)
  emit('update', $util.clone(selectedGoodIds.value))
  modalState.visible = false
  $util.message.success('保存成功')
}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #eee;
  height: 100%;
  overflow-y: auto;
  height: 600px;
}

.close {
  margin-left: 20px;
  color: red;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 3px 0 red;
  }
}

.binded {
  color: green;
}

.exist {
  color: red;
}

</style>
